import { CalculatorCategory } from '../types/calculator.types';
import { financialCategory } from './categories/financial';
import { healthCategory } from './categories/health';
import { educationCategory } from './categories/education';
import { lifestyleCategory } from './categories/lifestyle';
import { professionalCategory } from './categories/professional';

export const calculatorCategories: CalculatorCategory[] = [
  financialCategory,
  healthCategory,
  educationCategory,
  lifestyleCategory,
  professionalCategory
];

export default calculatorCategories;
